import { credentialApi } from '@api/credential/credential.api';

export const {
  useLazyLoadCredentialsQuery,
  useLazyLoadLimitCredentialsQuery,
  useAddCredentialMutation,
  useDeleteCredentialMutation,
} = credentialApi;
